import gsap from 'gsap';
import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import { MENU_CLOSE, MENU_OPEN } from '../lib/events';//COMPONENT_INIT

export default el => {

    const $el = $(el);
    const header = $el.parent('[role="banner"]').get(0);
    const burger = $el.find('[data-burger]').get(0);
    const menu = $el.find('[data-menu]').get(0);

    let isOpen = false;
    let focusedElement = null;

    const open = (tween = true) => {
        if (isOpen) {
            return;
        }
        isOpen = true;
        focusedElement = document.activeElement || null;
        $(menu).removeClass('hidden');
        $(burger).attr({ 'aria-expanded': 'true' });
        if (tween) {
            gsap.timeline()
                .fromTo(menu, { opacity: 0 }, { opacity: 1, duration: 0.3 })
                .set(menu, { clearProps: 'all' });
        } else {
            gsap.killTweensOf(menu);
            gsap.set(menu, { clearProps: 'all' });
        }
        Viewport.lockTabbing(header, burger);
        Dispatch.emit(MENU_OPEN);
    };

    const close = (tween = true) => {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        const afterClose = () => {
            Viewport.releaseTabbing(focusedElement);
            focusedElement = null;
            gsap.set(menu, { clearProps: 'all' });
            $(menu).addClass('hidden');
            $(burger).attr({ 'aria-expanded': 'false' });
        };
        Dispatch.emit(MENU_CLOSE);
        if (!tween) {
            gsap.killTweensOf(menu);
            afterClose();
            return;
        }
        gsap.timeline({
            onComplete: afterClose
        })
            .to(menu, { opacity: 0, duration: 0.3 });
    };

    const onBurgerClick = () => {
        if (!isOpen) {
            open();
        } else {
            close();
        }
    };

    const onBreakpoint = () => {
        requestAnimationFrame(() => {
            if (!burger.offsetParent) {
                close(false);
            }
        });
    };

    const onKeyUp = e => {
        if (!isOpen) {
            return;
        }
        const key = e.key || e.which || e.keyCode || null;
        if (['Escape', 27].indexOf(key) > -1) {
            close();
        }
    };

    const init = () => {
        $(burger).on('click', onBurgerClick);
        $(menu).on('click', 'a,button', close);
        $('body').on('keyup', onKeyUp);
        Viewport.on('breakpoint', onBreakpoint);
        //Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        $(burger).off('click');
        $(menu).off('click');
        $('body').off('keyup', onKeyUp);
        Viewport.off('breakpoint', onBreakpoint);
    };

    return {
        init,
        destroy
    };

};
